import { Link, useOutletContext } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { useAuth } from '@/hooks/useAuth'
import { useInstitution } from '@/contexts/InstitutionContext'
import type { WinnerLookupLayoutOutletContext } from '@/layouts/WinnerLookupLayout'
import { RaspadinhaWinnersSection } from './sections/RaspadinhaWinnersSection'
import { RoletaWinnersSection } from './sections/RoletaWinnersSection'
import { SorteioWinnersSection } from './sections/SorteioWinnersSection'
import styles from './WinnerLookupPage.module.css'

export function WinnerLookupPage() {
  const { guard, token, isCollaborator } = useAuth()
  const { institutionId } = useInstitution()
  const { campaignId, campaignsLoading, hasCampaigns } =
    useOutletContext<WinnerLookupLayoutOutletContext>()

  if (guard === 'admin' && institutionId === null && !campaignsLoading) {
    return (
      <div className={styles.centered}>
        <Icon icon="mdi:office-building-outline" className={styles.errorIcon} />
        Selecione uma instituição no topo para consultar ganhadores.
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div>
          <h2 className={styles.title}>Visão geral</h2>
          <p className={styles.subtitle}>
            Consulte ganhadores do sorteio, prêmios distribuídos na roleta e contemplados na
            raspadinha — cada bloco usa a campanha correspondente.
          </p>
        </div>
        <nav className={styles.breadcrumb} aria-label="Navegação">
          <Link to="/home">Home</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span>Ganhadores</span>
        </nav>
      </div>

      <SorteioWinnersSection
        campaignId={campaignId}
        isLoading={campaignsLoading}
        hasCampaigns={hasCampaigns}
      />
      <RoletaWinnersSection
        campaignId={campaignId}
        isLoading={campaignsLoading}
        hasCampaigns={hasCampaigns}
        token={token}
        canUpdateStatus={!isCollaborator}
      />
      <RaspadinhaWinnersSection />
    </div>
  )
}
